import type { ReOSDatabase, ReOSNotification } from "./types";
import { stockReviewIsDue } from "./stock";

export const STOCK_REVIEW_GROUP = "stock_review_group";

/** Display grouping only: the underlying item tasks retain their individual identities. */
export function prioritizedWorkQueue(notifications: ReOSNotification[], database: ReOSDatabase, now = new Date()): ReOSNotification[] {
  const aging = notifications.filter((notice) => notice.type === "aging_stock" && database.inventoryItems.some((item) => item.id === notice.itemID && stockReviewIsDue(item, now)));
  const tasks = notifications.filter((notice) => notice.type !== "aging_stock");
  if (aging.length) tasks.push({ ...aging[0], id: STOCK_REVIEW_GROUP, itemID: undefined, listingID: undefined,
    groupCount: new Set(aging.map((notice) => notice.itemID)).size, title: "Review aging stock", body: "Check prices, photos and listing status.",
    createdAt: aging.reduce((earliest, notice) => notice.createdAt < earliest ? notice.createdAt : earliest, aging[0].createdAt) });
  function priority(notice: ReOSNotification): number {
    if (notice.type === "cross_listing_conflict") return 0;
    const sale = database.sales.find((candidate) => candidate.id === notice.saleID);
    if (notice.type === "shipping_due") return sale?.shipBy && Date.parse(sale.shipBy) < now.getTime() ? 1 : 3;
    if (["marketplace_sale_detected", "listing_failed", "marketplace_connection_error", "research_failed"].includes(notice.type)) return 2;
    if (["research_needs_input", "research_ready"].includes(notice.type)) return 4;
    if (notice.type === "aging_stock") return 6;
    return 5;
  }
  function due(notice: ReOSNotification) {
    const sale = database.sales.find((candidate) => candidate.id === notice.saleID);
    return Date.parse(notice.type === "shipping_due" && sale?.shipBy ? sale.shipBy : notice.createdAt) || 0;
  }
  return tasks.sort((a, b) => priority(a) - priority(b) || due(a) - due(b) || a.id.localeCompare(b.id));
}
